<div class="container-fluid">
    <div class="card">
        <div class="card-body">
            <app-search-view>
                <app-refund-search #app filters></app-refund-search>
                <div grid>
                    <app-refund-table
                        [refunds]="contents"
                        [sortField]="searchService.field ?? null"
                        [sortOrder]="(searchService.direction === 'ASC' ? 'ASC' : 'DESC')"
                        [showActions]="true"
                        [menuItemsForRefund]="buildMenuItemsForRefund"
                        [clickable]="true"
                        [isExpanded]="isRefundExpanded"
                        (sortChange)="onSortChange($event, app)"
                        (rowClick)="onRowClick($event)">
                        <ng-template #expandedRow let-row>
                            <td class="events-cell" [attr.colspan]="11">
                                <div class="events-container">
                                    <div class="events-title">Refund Details</div>
                                    <table class="table events-table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Refund Link</th>
                                            <th scope="col">Expires at</th>
                                            <th scope="col">Failure Reason</th>
                                            <th scope="col">Refund Key</th>
                                            <th scope="col">Last Updated</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <span class="p-column-title">Refund Link</span>
                                                @if (row.refund?.refundUrl) {
                                                    <a [href]="row.refund?.refundUrl"
                                                       target="_blank"
                                                       rel="noopener noreferrer">{{ row.refund?.refundUrl }}</a>
                                                    <button type="button"
                                                            class="link-copy-btn"
                                                            (click)="copyRefundLink(row)">Copy</button>
                                                } @else {
                                                    -
                                                }
                                            </td>
                                            <td>
                                                <span class="p-column-title">Expires at</span>
                                                @if (row.refund?.expiresAt) {
                                                    {{ row.refund?.expiresAt | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                                                } @else {
                                                    -
                                                }
                                            </td>
                                            <td>
                                                <span class="p-column-title">Failure Reason</span>
                                                {{ row.refund?.failureMessage ?? '-' }}
                                            </td>
                                            <td>
                                                <span class="p-column-title">Refund Key</span>
                                                {{ row.refund?.refundKey ?? '-' }}
                                            </td>
                                            <td>
                                                <span class="p-column-title">Last Updated</span>
                                                @if (row.refund?.dateTimeUpdated) {
                                                    {{ row.refund?.dateTimeUpdated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
                                                } @else {
                                                    -
                                                }
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </ng-template>
                    </app-refund-table>
                </div>
            </app-search-view>
        </div>
    </div>
</div>
